export const movies = [
  {
    id: "an-yong-zhi-cheng",
    title: "暗涌之城",
    type: "剧集",
    region: "国产",
    country: "中国大陆",
    year: 2024,
    genres: ["犯罪", "悬疑", "都市"],
    language: "国语",
    duration: "全 12 集 / 单集 48 分钟",
    director: "沈砺",
    cast: ["江砚川", "陆惟宁", "周诩", "程嘉禾"],
    rating: 9.1,
    views: 386.4,
    addedAt: "2025-09-12",
    updatedAt: "2025-10-14",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20of%20a%20rain-soaked%20harbor%20city%20at%20night%2C%20lone%20figure%20in%20a%20long%20coat%20standing%20on%20a%20container%20dock%2C%20reflections%20of%20amber%20lights%20on%20wet%20asphalt%2C%20deep%20violet%20and%20orange%20color%20grading%2C%20heavy%20atmospheric%20fog%2C%20dramatic%20low-key%20lighting%2C%20no%20text%2C%20fine%20film%20grain%2C%20highly%20detailed%20editorial%20composition&width=600&height=900&seq=poster-anyong-01&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20night%20shot%20of%20a%20neon-lit%20harbor%20district%20in%20the%20rain%2C%20stacked%20shipping%20containers%2C%20warm%20amber%20street%20lamps%20cutting%20through%20mist%2C%20deep%20violet%20sky%2C%20reflective%20wet%20ground%2C%20moody%20crime%20drama%20aesthetic%2C%20no%20text%2C%20anamorphic%20film%20look&width=1600&height=900&seq=still-anyong-01&orientation=landscape",
    tagline: "这座城市所有的沉默，都在替某个人保守秘密。",
    summary:
      "一桩看似普通的港口失踪案，牵出横跨十二年的利益网络。刑警顾岚在追查中逐渐发现，自己要找的凶手可能就坐在同一间会议室里。",
    plot: [
      "《暗涌之城》把镜头对准一座依靠港口生长的南方城市。开场是一次例行清点：编号 417 的集装箱里少了一具本该存在的货物记录，取而代之的是一份被人为抹去的时间表。刑警顾岚接手这桩几乎没人愿意立案的失踪案，她原以为只需要三天，结果一头撞进了这座城市最不愿被翻开的旧账本。",
      "剧集的重心并不在追凶本身，而在追凶过程中人与人之间缓慢裂开的关系。顾岚的搭档老周在体制里待了二十年，习惯把每一份报告写得滴水不漏；港务局的年轻调度员林知意只想保住父亲留下的那份工作；而始终站在阴影里的商人韩阔，则用体面的慈善晚宴遮住了整条灰色链条。三条线交错推进，每一次接近真相，都伴随着一个普通人被推上代价的位置。",
      "值得称道的是全剧对“沉默”的处理。它不靠密集的反转取胜，而是让观众在大量留白里自行拼合线索：一段被剪掉的监控、一句说了一半的证词、一次刻意绕远的路。到第八集，当顾岚终于拿到那份被藏了十二年的调度记录时，剧集已经完成了从案件叙事到城市寓言的转身。",
      "结局没有给出痛快的清算，而是让所有人在潮水退去后各自站定。顾岚升了职，却再也没能回到最初那个相信程序可以解决一切的自己。这种克制的收束，正是它比同类型作品更耐看的地方。",
    ],
    tags: ["港城悬疑", "群像叙事", "慢热佳作", "实力派阵容"],
    featured: true,
  },
  {
    id: "wu-zhong-lai-xin",
    title: "雾中来信",
    type: "剧集",
    region: "国产",
    country: "中国大陆",
    year: 2025,
    genres: ["悬疑", "家庭", "剧情"],
    language: "国语",
    duration: "全 10 集 / 单集 45 分钟",
    director: "唐昀",
    cast: ["许澄", "梁书禾", "白未", "姜迟"],
    rating: 8.9,
    views: 412.7,
    addedAt: "2025-10-02",
    updatedAt: "2025-10-17",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20misty%20mountain%20town%20at%20dawn%2C%20a%20woman%20holding%20an%20old%20envelope%20seen%20from%20behind%2C%20dense%20white%20fog%20between%20pine%20trees%2C%20pale%20cool%20grey%20and%20soft%20violet%20tones%20with%20a%20single%20warm%20lamp%2C%20quiet%20melancholic%20mood%2C%20no%20text%2C%20fine%20grain%2C%20elegant%20restrained%20composition&width=600&height=900&seq=poster-wuzhong-02&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Atmospheric%20wide%20shot%20of%20a%20small%20mountain%20town%20wrapped%20in%20morning%20fog%2C%20tiled%20roofs%20and%20narrow%20stone%20stairs%2C%20a%20single%20lit%20window%2C%20mist%20layers%20over%20pine%20forest%2C%20muted%20cool%20palette%20with%20soft%20amber%20accents%2C%20cinematic%20mystery%20drama%20aesthetic%2C%20no%20text&width=1600&height=900&seq=still-wuzhong-02&orientation=landscape",
    tagline: "有些信寄了二十年，才终于找到该读它的人。",
    summary:
      "小镇邮局整理旧件时发现一沓从未投递的信。女儿循着收件人地址回到母亲年轻时生活的地方，也把一段被全家默契封存的往事重新拆开。",
    plot: [
      "故事从一个很小的职业细节开始：邮局清理积压旧件，规定满二十年的无主信件可以销毁。整理员在纸箱底部发现一沓同一个人寄出的信，收件地址是镇上一处早就不存在的门牌。她把这些信交给了寄件人早已离世的女儿沈栀。",
      "沈栀回到雾山镇，本想只待三天。她带着母亲的骨灰和那沓信，逐一寻找当年的收件人：退休的语文老师、开杂货铺的夫妇、在山上守林的老人。每个人看到信封上的字迹都沉默片刻，然后讲出一段彼此矛盾又彼此补充的往事。剧集用这种方式，让一个已经无法开口的人，慢慢在别人的记忆里被重新拼凑出来。",
      "《雾中来信》最动人的地方在于它没有把母亲塑造成受害者。随着信件内容被读出，观众会发现她做过自私的选择，也承担了选择之后的全部重量。沈栀从最初想要一个答案，到后来只想弄清楚母亲当年到底害怕什么，这个过程构成了全剧真正的情感主线。",
      "最后一集，沈栀没有把信全部读完。她把最后一封留在山顶的旧邮筒里，转身下山。雾散开的那一瞬，剧集给出的不是和解，而是一种终于可以继续生活的许可。",
    ],
    tags: ["家庭悬疑", "女性视角", "慢节奏", "催泪"],
    featured: true,
  },
  {
    id: "jing-mo-de-pin-lv",
    title: "静默的频率",
    type: "剧集",
    region: "海外",
    country: "美国",
    year: 2025,
    genres: ["科幻", "悬疑", "剧情"],
    language: "英语",
    duration: "全 8 集 / 单集 52 分钟",
    director: "Elliot Vance",
    cast: ["Margot Reed", "Daniel Okoye", "Clara Bennett"],
    rating: 9.0,
    views: 297.5,
    addedAt: "2025-08-21",
    updatedAt: "2025-10-11",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20poster%20of%20a%20lonely%20radio%20telescope%20dish%20in%20a%20desert%20at%20blue%20hour%2C%20a%20small%20silhouetted%20figure%20walking%20toward%20it%2C%20thin%20concentric%20light%20rings%20in%20the%20sky%2C%20deep%20violet%20and%20dust%20orange%20grading%2C%20vast%20empty%20landscape%2C%20no%20text%2C%20subtle%20film%20grain%2C%20minimal%20elegant%20science%20fiction%20artistry&width=600&height=900&seq=poster-jingmo-03&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20desert%20landscape%20at%20dusk%20with%20a%20giant%20radio%20telescope%20dish%2C%20deep%20violet%20twilight%20sky%20with%20faint%20geometric%20light%20patterns%2C%20warm%20orange%20horizon%20glow%2C%20dust%20haze%2C%20minimal%20science%20fiction%20drama%20aesthetic%2C%20no%20text%2C%20anamorphic%20high%20detail&width=1600&height=900&seq=still-jingmo-03&orientation=landscape",
    tagline: "宇宙没有回答，但有人一直在听。",
    summary:
      "射电天文台连续七晚收到同一段无法归类的窄带信号。值班的研究员越往下追查，越怀疑这段信号来自一个早已被官方注销的观测项目。",
    plot: [
      "《静默的频率》用一个几乎静止的场景开场：荒漠深处的射电望远镜阵列，夜班研究员例行检查数据。第七个夜晚，系统捕捉到一段持续 11 秒的窄带信号，频率精确到不可能是自然噪声。",
      "女主角 Ada 是个习惯把所有异常都写成报告的人，但这一次，她的报告被层层退回，理由是“设备校准误差”。她开始私下追查信号的来源，发现二十年前有一个同样位置的观测项目曾经存在，又在某个时间点被整体注销，参与者全部签了保密协议。",
      "剧集的科幻设定始终保持克制：没有外星人露面，没有末日倒计时，只有不断重复的信号、被删除的磁带、以及一个越来越难分辨是记忆还是干扰的童年片段。当 Ada 最终确认信号的内容是一段被压缩的人类语言时，观众才意识到真正的谜题不是“谁在发送”，而是“为什么要让它被听见”。",
      "八集的篇幅让故事没有任何注水空间。结尾她把观测记录公开上传，然后关掉设备，走出控制室。天已经亮了，沙漠上什么都没有，但那种被注视过的感觉留在了镜头里。",
    ],
    tags: ["硬科幻", "慢热神作", "氛围流", "哲学思辨"],
    featured: true,
  },
  {
    id: "chang-ye-jiang-jin",
    title: "长夜将近",
    type: "电影",
    region: "国产",
    country: "中国大陆",
    year: 2023,
    genres: ["剧情", "悬疑", "犯罪"],
    language: "国语",
    duration: "127 分钟",
    director: "罗砚",
    cast: ["沈望", "叶青禾", "陈叙"],
    rating: 8.7,
    views: 268.9,
    addedAt: "2025-06-18",
    updatedAt: "2025-09-30",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20of%20a%20man%20standing%20alone%20on%20an%20empty%20highway%20at%20night%2C%20headlights%20approaching%20from%20far%20away%2C%20rain%20streaks%20in%20the%20air%2C%20dark%20violet%20sky%20with%20a%20thin%20amber%20band%20at%20the%20horizon%2C%20lonely%20tense%20mood%2C%20no%20text%2C%20grainy%2035mm%20texture%2C%20dramatic%20contrast&width=600&height=900&seq=poster-changye-04&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Empty%20rainy%20highway%20at%20night%20stretching%20into%20darkness%2C%20single%20car%20headlights%20in%20the%20distance%2C%20wet%20reflective%20asphalt%2C%20deep%20violet%20and%20amber%20cinematic%20grading%2C%20low%20key%20lighting%2C%20no%20text%2C%20film%20noir%20atmosphere%2C%20anamorphic%20flare&width=1600&height=900&seq=still-changye-04&orientation=landscape",
    tagline: "他只想把这一夜开完，可这一夜不想放过他。",
    summary:
      "一名货车司机在雨夜顺路载了一个陌生人，天亮之前，他必须决定要不要把这个人交给等在下一个收费站的警察。",
    plot: [
      "《长夜将近》是一部几乎全部发生在车里的电影。货车司机老陈跑了十七年长途，习惯了在凌晨两点到四点之间保持沉默。这一夜，他在国道边停下车，让一个浑身湿透的年轻人上了副驾。",
      "年轻人说自己只是要去前面的县城找亲戚，但后座那个被雨水泡软的旅行袋、以及他反复查看后视镜的习惯，让老陈很快明白事情没那么简单。与此同时，电台里插播了一条协查通告，描述的正是副驾上这个人的体貌特征。",
      "影片最大的张力来自老陈的选择过程。他不是英雄，也没打算做英雄：他有一笔还没还完的车贷，一个正在读高三的女儿，和一份经不起任何意外的驾照。导演用大量近景和挡风玻璃上的雨痕，把判断的重量压在一个普通中年人的脸上。",
      "最终他既没有报警，也没有放人。他把车停在收费站前两公里的应急车道，让年轻人自己走。这个决定不道德也不正确，却足够真实。片尾天光初亮，老陈继续往前开，后视镜里空无一人。",
    ],
    tags: ["公路片", "小成本佳作", "人性拷问", "雨夜氛围"],
    featured: true,
  },
  {
    id: "di-qi-ge-xia-tian",
    title: "第七个夏天",
    type: "电影",
    region: "国产",
    country: "中国大陆",
    year: 2022,
    genres: ["爱情", "剧情", "青春"],
    language: "国语",
    duration: "112 分钟",
    director: "温子栖",
    cast: ["林晏", "苏白露", "何清"],
    rating: 8.2,
    views: 189.3,
    addedAt: "2025-05-06",
    updatedAt: "2025-08-19",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20film%20poster%20of%20two%20teenagers%20sitting%20on%20a%20seawall%20in%20summer%20dusk%2C%20bicycles%20leaning%20nearby%2C%20golden%20sunset%20light%20and%20soft%20lilac%20sky%2C%20sea%20breeze%20in%20hair%2C%20nostalgic%20grainy%20film%20photography%2C%20no%20text%2C%20tender%20bittersweet%20mood%2C%20cinematic%20composition&width=600&height=900&seq=poster-diqige-05&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Seaside%20town%20in%20late%20summer%20evening%2C%20two%20bicycles%20parked%20by%20a%20concrete%20seawall%2C%20golden%20hour%20sunlight%20and%20lavender%20sky%2C%20distant%20ferris%20wheel%2C%20warm%20nostalgic%20cinematic%20grading%2C%20no%20text%2C%20soft%20film%20grain&width=1600&height=900&seq=still-diqige-05&orientation=landscape",
    tagline: "那个夏天没有结束，只是我们不再回去了。",
    summary:
      "同一座海边小城，同一段防波堤，两个人在七个夏天里反复相遇又走散。时间把少年变成大人，也把一些话永远留在了那年。",
    plot: [
      "影片以七个夏天为章节，每一章都从同一段防波堤开始。十七岁那年，程野在这里遇见了从外地转学来的夏蔚，两个人因为一辆掉链子的旧自行车认识，也因为这辆自行车第一次一起看到了海上的落日。",
      "接下来的六个夏天，他们时而靠近，时而错过：高考后的那个夏天，一个人去了北方，一个人留在了原地；二十三岁的夏天，他们在同学婚礼上重逢，谁都没有提起当年那封没寄出的信；二十九岁的夏天，程野带着未婚妻回小城办手续，在防波堤上看到夏蔚正带着一群孩子写生。",
      "导演没有把故事拍成苦情的错过，而是耐心地呈现两个人各自成长的速度差。那些没能说出口的话，并不是因为不够爱，而是因为当时的他们确实不知道该怎么开口。影片中反复出现的那辆旧自行车，最终被修好、上漆，送给了夏蔚的学生。",
      "结尾停在第七个夏天。海还是那片海，两个人肩并肩坐着，聊的是天气和房价。观众却知道，有些东西已经彻底安放好了。",
    ],
    tags: ["青春回忆", "海边小城", "治愈系", "遗憾美学"],
  },
  {
    id: "tie-gui-yu-yue-liang",
    title: "铁轨与月亮",
    type: "电影",
    region: "海外",
    country: "法国",
    year: 2023,
    genres: ["剧情", "文艺", "公路"],
    language: "法语",
    duration: "134 分钟",
    director: "Luc Moreau",
    cast: ["Camille Roux", "Théo Marchand"],
    rating: 8.5,
    views: 96.2,
    addedAt: "2025-04-22",
    updatedAt: "2025-07-28",
    poster:
      "https://readdy.ai/api/search-image?query=Poetic%20European%20art%20film%20poster%20of%20old%20railway%20tracks%20crossing%20a%20lavender%20field%20under%20a%20large%20moon%2C%20distant%20small%20figure%20walking%20along%20the%20rails%2C%20dusk%20violet%20sky%2C%20soft%20silver%20and%20warm%20ochre%20tones%2C%20no%20text%2C%20analog%20film%20texture%2C%20quiet%20melancholic%20composition&width=600&height=900&seq=poster-tiegui-06&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Abandoned%20railway%20line%20cutting%20through%20a%20vast%20lavender%20field%20at%20dusk%2C%20full%20moon%20rising%2C%20soft%20violet%20sky%2C%20warm%20ochre%20highlights%20on%20the%20grass%2C%20distant%20village%20silhouette%2C%20cinematic%20european%20art%20film%20look%2C%20no%20text%2C%20fine%20grain&width=1600&height=900&seq=still-tiegui-06&orientation=landscape",
    tagline: "修表匠说，走得慢的表，才是准的。",
    summary:
      "一位退休的铁路信号员决定沿着废弃支线走到终点，去看四十年前没能赴约的那座小站。路上他遇到的人，替他还完了一段没说完的话。",
    plot: [
      "老铁路信号员安托万在妻子去世后，收到一封寄错的信。信里提到一座早已停运的小站，正是四十年前他因为值班没能赴约的地方。他翻出旧制服和一只坏掉的怀表，决定沿着废弃支线走过去。",
      "这趟旅程没有惊险，只有不断出现的普通人：开拖拉机的农场主、在路边卖旧书的年轻女人、临时住在旧车站的移民家庭。每个人听他讲一段往事，也回赠他一段自己的故事。安托万原本只想抵达，却在路上慢慢意识到，他一直要找的其实不是那座站台，而是一个可以原谅自己的理由。",
      "影片的摄影几乎全是自然光，铁轨、麦田、月亮的构图一带一换，情绪始终平缓。导演很懂得什么时候不说话——有一段长达三分钟的镜头，只是老人坐在站台长椅上，等一班不会来的车。",
      "结尾他终于走到终点，站台上长满野草。他把那只坏掉的怀表挂在柱子上，坐下来抽了根烟，然后起身回头。所谓和解，大概就是不用再往前走了。",
    ],
    tags: ["欧洲文艺", "慢电影", "旅途叙事", "摄影一流"],
  },
  {
    id: "bei-fang-hang-xian",
    title: "北方航线",
    type: "剧集",
    region: "海外",
    country: "英国",
    year: 2024,
    genres: ["冒险", "剧情", "悬疑"],
    language: "英语",
    duration: "全 8 集 / 单集 50 分钟",
    director: "Harriet Cole",
    cast: ["Owen Blake", "Ingrid Salvesen", "Marcus Hale"],
    rating: 8.8,
    views: 174.8,
    addedAt: "2025-03-14",
    updatedAt: "2025-09-06",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20a%20icebreaker%20ship%20crossing%20a%20dark%20arctic%20sea%2C%20frozen%20waves%20in%20the%20foreground%2C%20faint%20green%20and%20violet%20aurora%20in%20the%20night%20sky%2C%20tiny%20deck%20lights%2C%20cold%20desaturated%20palette%20with%20one%20warm%20amber%20glow%2C%20no%20text%2C%20epic%20atmospheric%20adventure%20drama%20composition&width=600&height=900&seq=poster-beifang-07&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Arctic%20icebreaker%20ship%20moving%20through%20broken%20sea%20ice%20at%20night%2C%20aurora%20borealis%20in%20violet%20and%20soft%20green%2C%20deck%20lights%20reflecting%20on%20frozen%20water%2C%20vast%20empty%20horizon%2C%20cinematic%20cold%20palette%2C%20no%20text%2C%20high%20detail%20wide%20shot&width=1600&height=900&seq=still-beifang-07&orientation=landscape",
    tagline: "航线图上没有的那一段，才是真正的航程。",
    summary:
      "一艘执行科考任务的破冰船在返航途中接到求救信号，信号来自一条三十年前就被从海图上抹掉的航道。",
    plot: [
      "《北方航线》开场就把观众放进一个封闭空间：一艘载着十四名船员的破冰船，在极夜的海面上执行完例行科考任务，准备返航。船长接到一段断续的求救信号，坐标落在一处从未在现行海图上标注过的位置。",
      "决定改航只用了一分钟，代价却贯穿全剧。八集的故事在冰面、船舱和无线电之间展开：有人主张继续执行救援，有人坚持必须保护任务数据，还有人开始怀疑这段信号根本就是某个人的把戏。船上没有真正的反派，每个人的选择都能被理解，这正是剧集最紧绷的部分。",
      "随着航行深入，被遗忘的航道逐渐显露出与三十年前一次事故的联系。剧集把悬念控制得很稳，每集结尾只递进一小步，却在人物关系上不断加压。你会发现自己关心的问题从“信号是谁发的”，慢慢变成了“这艘船还能不能完整地回去”。",
      "结尾的极夜风暴是整部剧的视觉高点。幸存的船员站上甲板看日出，没有人欢呼。剧集没有给出宏大结论，只留下一个问题：为了救一个陌生人，值不值得让所有人冒险。",
    ],
    tags: ["极地冒险", "密闭空间", "群像", "高完成度"],
  },
  {
    id: "bai-ta-zhi-xia",
    title: "白塔之下",
    type: "剧集",
    region: "海外",
    country: "韩国",
    year: 2024,
    genres: ["悬疑", "复仇", "剧情"],
    language: "韩语",
    duration: "全 10 集 / 单集 46 分钟",
    director: "박서준",
    cast: ["한지원", "윤도현", "최민서"],
    rating: 8.6,
    views: 223.1,
    addedAt: "2025-02-27",
    updatedAt: "2025-08-08",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20poster%20of%20an%20imposing%20white%20concrete%20tower%20against%20a%20stormy%20violet%20sky%2C%20a%20woman%20in%20a%20black%20coat%20looking%20up%2C%20rain%20and%20strong%20wind%2C%20stark%20architectural%20shadows%2C%20single%20amber%20window%20lit%2C%20no%20text%2C%20cold%20elegant%20revenge%20thriller%20aesthetic&width=600&height=900&seq=poster-baita-08&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Brutalist%20white%20concrete%20headquarters%20building%20under%20a%20storm%2C%20dark%20violet%20clouds%2C%20wet%20plaza%20with%20reflections%2C%20one%20warm%20lit%20window%20high%20up%2C%20cold%20minimal%20cinematic%20thriller%20look%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=still-baita-08&orientation=landscape",
    tagline: "她花了十年爬上来，只为了拆掉这座楼。",
    summary:
      "十年前一桩被认定为意外的坠楼案，让一个家庭彻底消失。十年后，幸存下来的女儿以另一种身份进入那座大楼，开始了漫长的清算。",
    plot: [
      "白塔是这座城市最高的企业总部，也是剧名的来源。女主角尹昭熙在十年前失去父亲，官方结论是意外坠楼。她用了十年时间改名、读书、进入对手公司积累资历，只为有一天能以合规的方式走进白塔的会议室。",
      "剧集没有把她塑造成无所不能的复仇者。她会被调岗，会被威胁，也会在关键时刻犹豫。真正让故事好看的是她与对手之间不断变化的博弈关系：有人被她拉拢，有人反手出卖她，还有人明明知道真相，却因为家人还在对方手下工作而选择沉默。",
      "《白塔之下》最见功力的是把复仇拍成了一场关于证据的慢功夫。没有离奇的天降录音，只有一次次翻旧档案、找证人、算时间差。观众跟着她一点点把当年的时间线补齐，那种冷静推进的快感远比爽剧式的暴击更过瘾。",
      "最后一集，她没有把对手推下楼。她把所有材料提交给监管部门，然后站在一楼大厅看着员工陆续离开。这场胜利代价极大，但剧集始终保持了底线。",
    ],
    tags: ["复仇爽剧", "职场博弈", "女性主角", "反转不断"],
  },
  {
    id: "shen-ye-liang-dian-ban",
    title: "深夜两点半",
    type: "电影",
    region: "海外",
    country: "日本",
    year: 2022,
    genres: ["剧情", "治愈", "美食"],
    language: "日语",
    duration: "118 分钟",
    director: "小林悠真",
    cast: ["佐藤玲", "中村圭", "山本千夏"],
    rating: 8.3,
    views: 138.6,
    addedAt: "2025-01-19",
    updatedAt: "2025-06-21",
    poster:
      "https://readdy.ai/api/search-image?query=Warm%20intimate%20film%20poster%20of%20a%20tiny%20late-night%20diner%20in%20a%20narrow%20Japanese%20alley%2C%20steam%20rising%20from%20a%20pot%2C%20glowing%20paper%20lantern%2C%20one%20customer%20seated%20at%20the%20counter%2C%20amber%20light%20against%20deep%20indigo%20night%2C%20cozy%20nostalgic%20mood%2C%20no%20text%2C%20film%20photography%20texture&width=600&height=900&seq=poster-shenye-09&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Narrow%20Japanese%20alley%20at%202am%20with%20a%20small%20diner%2C%20warm%20lantern%20glow%20spilling%20onto%20wet%20cobblestones%2C%20steam%20and%20soft%20rain%2C%20deep%20indigo%20night%20with%20amber%20highlights%2C%20cinematic%20cozy%20slice%20of%20life%20look%2C%20no%20text&width=1600&height=900&seq=still-shenye-09&orientation=landscape",
    tagline: "这个点还醒着的人，都有不想回去的地方。",
    summary:
      "东京一条小巷里的深夜食堂，只在两点半到天亮之间营业。老板娘说，来的人不是饿了，是有些事情还没咽下去。",
    plot: [
      "影片的舞台只有一间不到十平米的食堂：六个吧台座位，一口煮锅，一块写了三种菜名的黑板。营业时间是凌晨两点半到天亮，来的都是些在城市里被时间漏掉的人。",
      "全片由五个夜晚组成。第一夜，一个刚被裁员的中年男人点了一碗什么都没加的乌冬；第二夜，一对准备离婚的夫妻隔着吧台吃完最后一顿饭；第三夜，跑了整晚的代驾司机讲起自己老家的女儿。每一桌都有一个不肯说出口的理由，而老板娘从不追问，只在上菜的时候多放一勺汤。",
      "影片的温柔不是廉价的。它不承诺生活会变好，也不假装每个人都有救。第四夜出现的老人，年轻时抛下家庭去了东京，如今连儿子的住址都不知道。他吃完那碗饭，放下钱，什么也没解决就走了。",
      "最后一夜下起雪，老板娘在关门前给自己煮了一碗面。镜头拉远，小巷只剩下那盏灯。这种不煽情的收尾，反而让人记了很久。",
    ],
    tags: ["日式治愈", "美食番", "深夜氛围", "群像小故事"],
  },
  {
    id: "jiu-chang-pian-dian",
    title: "旧唱片店",
    type: "电影",
    region: "港台",
    country: "中国台湾",
    year: 2020,
    genres: ["爱情", "音乐", "剧情"],
    language: "国语",
    duration: "106 分钟",
    director: "黄允澄",
    cast: ["陈柏言", "林昀", "吴承翰"],
    rating: 8.1,
    views: 84.5,
    addedAt: "2024-12-08",
    updatedAt: "2025-05-12",
    poster:
      "https://readdy.ai/api/search-image?query=Nostalgic%20film%20poster%20of%20a%20cramped%20record%20store%20filled%20with%20vinyl%2C%20a%20young%20man%20flipping%20through%20sleeves%2C%20dust%20motes%20in%20a%20warm%20sunbeam%2C%20teal%20and%20amber%20film%20tones%2C%20rain%20on%20the%20window%2C%20quiet%20romantic%20mood%2C%20no%20text%2C%20analog%20grain%20and%20soft%20focus&width=600&height=900&seq=poster-changpian-10&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Interior%20of%20a%20small%20old%20record%20store%20in%20Taipei%2C%20wooden%20shelves%20packed%20with%20vinyl%2C%20warm%20afternoon%20sunlight%20through%20rainy%20window%2C%20dust%20in%20the%20air%2C%20vintage%20turntable%2C%20nostalgic%20cinematic%20grading%2C%20no%20text%2C%20shallow%20depth%20of%20field&width=1600&height=900&seq=still-changpian-10&orientation=landscape",
    tagline: "唱片会跳针，喜欢一个人不会。",
    summary:
      "一间即将关门的老唱片店里，打工的男孩遇见每周三来试听同一张唱片的女孩。他们用一首歌的时间，聊完了一整个夏天。",
    plot: [
      "台北的老街区里，有间开了三十年的唱片店，门上贴着“顶让”两个红字。暑假回家的大学生阿哲被老板留下看店，负责把这批黑胶一张张清掉。他不太懂音乐，只知道每天下午三点，会有一个女孩进来，戴上耳机，试听同一张唱片的第一首。",
      "女孩叫林昀，她不买，也不说话，只是每週三来听一遍，听完就走。阿哲从好奇到习惯，再到期待，花了六个星期。第七个星期，他终于开口问了一句：“这首歌有什么特别的？”女孩说，是她爸爸以前在车上放的。",
      "影片没有安排任何戏剧化的事件。两个人一起整理唱片、修唱盘、在店门口吃便当，感情就在这些琐碎的陪伴中自然发生。全片最好的一场戏，是停电的夜里，两个人用一台手摇唱机和一把吉他，把那张唱片重新演奏了一遍。",
      "结局女孩要去国外念书，店也终于关掉。阿哲把那张唱片留在了自己手里。多年后他在另一座城市开了一间很小的店，墙上挂着一块手写的营业时间牌。",
    ],
    tags: ["台湾小清新", "音乐主题", "慢热爱情", "怀旧"],
  },
  {
    id: "xue-xian-yi-shang",
    title: "雪线以上",
    type: "剧集",
    region: "国产",
    country: "中国大陆",
    year: 2023,
    genres: ["冒险", "剧情", "人性"],
    language: "国语",
    duration: "全 8 集 / 单集 47 分钟",
    director: "祁野",
    cast: ["贺兰", "乌兰巴特尔", "许行舟"],
    rating: 8.4,
    views: 132.7,
    addedAt: "2024-11-15",
    updatedAt: "2025-04-03",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20mountain%20adventure%20poster%20of%20a%20small%20climbing%20team%20on%20a%20narrow%20snow%20ridge%20at%20sunrise%2C%20wind-blown%20snow%2C%20dramatic%20violet%20shadows%20on%20the%20peaks%2C%20warm%20orange%20sunlight%20hitting%20the%20summit%2C%20vast%20scale%2C%20no%20text%2C%20epic%20realistic%20cinematography&width=600&height=900&seq=poster-xuexian-11&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Snow-covered%20mountain%20ridge%20at%20sunrise%20with%20three%20tiny%20climbers%20silhouetted%2C%20dramatic%20violet%20shadow%20and%20warm%20orange%20light%2C%20wind%20blown%20snow%20spindrift%2C%20vast%20alpine%20landscape%2C%20cinematic%20epic%20scale%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=still-xuexian-11&orientation=landscape",
    tagline: "山不记得你来过，但你会记得自己走了多远。",
    summary:
      "一支临时组建的登山队向未登峰进发，暴风雪提前到来。八集的篇幅里，真正的敌人不是山，是每个人心里的那一句“再往上一点”。",
    plot: [
      "《雪线以上》以一支援助性质的登山队为核心。队长老贺带过十几支商业队，这次接的是一支预算不足、成员水平参差的队伍。目标是一座没有正式登顶记录的六千米级山峰。",
      "前四集全在准备与适应：拉练、修路、分配物资、处理高原反应。剧集用大量细节呈现登山这项运动的枯燥和专业性，也因此让人物关系有了可信的落点。赞助商代表、纪录片摄影师、想证明自己的年轻队员、经验丰富却已过巅峰的老向导，每个人上山的目的都不一样。",
      "真正的转折出现在第五集。天气预报显示窗口期将提前关闭，队伍必须在放弃和强行冲顶之间选一个。导演没有把选择拍成简单的对错题：坚持的人有坚持的理由，撤退的人也不是懦弱。第八集的风雪救援戏，几乎全部用长镜头和实景拍摄完成，压迫感极强。",
      "剧集结尾，队伍只登顶了两个人，也失去了一位同伴。老贺在片尾说了一句话：“山永远在那儿，人只有一次。”这句台词被很多人记住，不是因为励志，而是因为它来得太晚。",
    ],
    tags: ["登山题材", "实景拍摄", "团队群像", "生死抉择"],
  },
  {
    id: "wu-ming-zhe-dang-an",
    title: "无名者档案",
    type: "剧集",
    region: "国产",
    country: "中国大陆",
    year: 2025,
    genres: ["谍战", "悬疑", "历史"],
    language: "国语",
    duration: "全 12 集 / 单集 45 分钟",
    director: "傅南亭",
    cast: ["章隼", "余知微", "老棘"],
    rating: 8.7,
    views: 205.9,
    addedAt: "2025-09-28",
    updatedAt: "2025-10-16",
    poster:
      "https://readdy.ai/api/search-image?query=Period%20spy%20thriller%20poster%20of%20an%20old%20archive%20room%20lit%20by%20a%20single%20desk%20lamp%2C%20man%20in%201940s%20coat%20examining%20a%20dossier%2C%20long%20shadows%20across%20filing%20cabinets%2C%20teal%20dark%20green%20and%20amber%20grading%2C%20dust%20in%20the%20air%2C%20no%20text%2C%20fine%20grain%20cinematic%20composition&width=600&height=900&seq=poster-wuming-12&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Amber-lit%20archives%20room%20with%20tall%20wooden%20filing%20cabinets%2C%20man%20in%20vintage%20coat%20reading%20documents%20at%20a%20desk%2C%20deep%20shadows%2C%20dust%20motes%20in%20lamp%20light%2C%20period%20spy%20thriller%20cinematic%20aesthetic%2C%20no%20text%2C%20warm%20amber%20and%20cool%20teal%20contrast&width=1600&height=900&seq=still-wuming-12&orientation=landscape",
    tagline: "档案上写着查无此人，可每个人都记得他。",
    summary:
      "一份被封存四十年的档案意外流出，里面记录着一个从未出现在任何名册上的人。年轻的研究员循着蛛丝马迹，拼出了一个无名者的一生。",
    plot: [
      "故事从一份被误装进普通卷宗的旧档案开始。年轻的研究员沈默在整理资料时，发现一张没有姓名、只有代号和三个日期的表格。按照流程，这份档案应该被重新封存，但他注意到，三个日期里有一个还没有到来。",
      "剧集采用双线结构：一边是沈默在当下追查档案的来源，一边是四十年前那个无名者在城市里执行任务的经过。两条线并不平均分配篇幅，而是通过物件产生呼应——一支钢笔、一份报纸、一张被反复折叠的车票。",
      "《无名者档案》在同类题材里少见地把重点放在“记录”本身。它关心的是一个人如何被从历史里抹掉，又如何在别人的记忆里留下痕迹。中段有一集几乎全部是对话，两个人在审讯室里就一份名单的真伪反复推敲，紧张程度却不输任何动作戏。",
      "结局沈默没有把档案公开，而是把它补完了最后一项内容，然后放回原处。他说，有些人不需要被记住，但应该被写下来。这个处理让整部剧的格局一下子打开了。",
    ],
    tags: ["年代谍战", "双线叙事", "档案谜题", "口碑黑马"],
  },
  {
    id: "yin-he-man-che",
    title: "银河慢车",
    type: "电影",
    region: "海外",
    country: "日本",
    year: 2024,
    genres: ["科幻", "动画", "治愈"],
    language: "日语",
    duration: "121 分钟",
    director: "新海凉",
    cast: ["花泽凛", "石川悠", "森下真昼"],
    rating: 9.2,
    views: 331.2,
    addedAt: "2025-07-30",
    updatedAt: "2025-10-09",
    poster:
      "https://readdy.ai/api/search-image?query=Anime%20style%20cinematic%20poster%20of%20a%20vintage%20train%20traveling%20across%20a%20starry%20sky%2C%20glowing%20rails%20suspended%20between%20clouds%2C%20two%20small%20passengers%20at%20the%20window%2C%20deep%20violet%20and%20warm%20amber%20nebula%20colors%2C%20shooting%20stars%2C%20dreamy%20melancholic%20mood%2C%20no%20text%2C%20highly%20detailed%20painterly%20illustration&width=600&height=900&seq=poster-yinhe-13&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Anime%20landscape%20of%20an%20old%20train%20crossing%20a%20bridge%20of%20light%20through%20a%20violet%20starfield%2C%20warm%20amber%20glow%20from%20the%20carriages%2C%20glowing%20rails%2C%20soft%20clouds%20below%2C%20dreamy%20nostalgic%20animation%20aesthetic%2C%20no%20text%2C%20highly%20detailed%20painterly%20look&width=1600&height=900&seq=still-yinhe-13&orientation=landscape",
    tagline: "这趟车不报站，但每个人都知道自己该在哪下。",
    summary:
      "一辆只在深夜出现的列车，载着还没准备好告别的人，驶向他们在心里偷偷想念的地方。少年为了找回妹妹，坐上了这趟不折返的慢车。",
    plot: [
      "《银河慢车》的世界观很简单：世界上有一趟只在深夜运行的列车，乘客都是那些心里还有未了之事的人。列车不报站，每个人会在自己该下的时候自然知道。",
      "少年悠人的妹妹在一年前意外离世。他偶然在铁道口看见那趟列车，追了上去。车厢里坐满了沉默的乘客：有想再见父亲一面的中年女人，有还没说完道歉的年轻士兵，也有一位始终不肯下车的老先生。",
      "影片用一节车厢一个故事的方式推进，每个短章都在讨论同一种情绪——我们对逝去之人的执念，到底是在思念他们，还是在安慰自己。悠人在旅途中逐渐明白，他一直想找回的不是妹妹，而是那个还没有做好告别的自己。",
      "结尾列车抵达一处星海边缘，妹妹就站在那里。两人聊了几句家常，然后她转身走了。悠人没有追。回到现实世界时天刚亮，他骑车经过那处铁道口，第一次没有停下来。",
    ],
    tags: ["动画电影", "奇幻治愈", "告别主题", "画面绝美"],
  },
  {
    id: "gui-tu-san-shi-li",
    title: "归途三十里",
    type: "电影",
    region: "国产",
    country: "中国大陆",
    year: 2019,
    genres: ["剧情", "公路", "家庭"],
    language: "国语",
    duration: "104 分钟",
    director: "薛青山",
    cast: ["任长河", "苗青", "小石头"],
    rating: 7.9,
    views: 76.4,
    addedAt: "2024-10-02",
    updatedAt: "2025-02-17",
    poster:
      "https://readdy.ai/api/search-image?query=Rural%20Chinese%20road%20movie%20poster%20of%20an%20old%20man%20and%20a%20child%20walking%20along%20a%20dirt%20road%20at%20dusk%2C%20golden%20fields%20and%20distant%20mountains%2C%20warm%20ochre%20and%20dusty%20violet%20tones%2C%20long%20shadows%2C%20no%20text%2C%20documentary%20like%20film%20grain%2C%20quiet%20emotional%20composition&width=600&height=900&seq=poster-guitu-14&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Long%20dirt%20road%20through%20golden%20wheat%20fields%20at%20dusk%2C%20an%20old%20man%20and%20a%20small%20child%20walking%20in%20the%20distance%2C%20dusty%20warm%20light%2C%20violet%20evening%20sky%2C%20rural%20China%20landscape%2C%20cinematic%20documentary%20style%2C%20no%20text%2C%20soft%20grain&width=1600&height=900&seq=still-guitu-14&orientation=landscape",
    tagline: "三十里路，走了大半辈子。",
    summary:
      "在城里打工失败的老周带着孙子回村，三十里山路走了一整天。路上他们遇到的人，把这些年没说的话一句句补齐了。",
    plot: [
      "老周在城里的工地干了八年，最后因为一场纠纷被辞退。他带着六岁的孙子小石头回村，身上只剩两百多块钱。从镇上到村里没有班车，三十里山路，他决定走回去。",
      "影片的叙事全部落在这条路上。祖孙俩经过砖厂、废弃的小学、正在修的高架桥，遇到开三轮的老乡、在路边卖西瓜的妇人、以及一个同样在返乡的年轻人。每一段短暂的相遇，都补上了老周这些年缺席的村庄变化。",
      "小石头一路问问题：为什么路要修得这么宽，为什么村里没有小朋友。老周的回答有时敷衍，有时沉默。观众慢慢意识到，他真正害怕的不是回到村里，而是回到那个已经没有人等他回去的家。",
      "最后三公里下起雨，老周把外套脱下来裹住孙子，自己淋着走。到村口时，老屋的灯居然是亮的——邻居知道他要回来，提前帮着开了门。这场戏没有任何煽情配乐，只有一个长镜头，节奏克制得让人心里发闷。",
    ],
    tags: ["乡土现实", "祖孙情", "小成本", "真实感"],
  },
  {
    id: "jing-xiang-fang-jian",
    title: "镜像房间",
    type: "电影",
    region: "海外",
    country: "西班牙",
    year: 2023,
    genres: ["惊悚", "悬疑", "心理"],
    language: "西班牙语",
    duration: "109 分钟",
    director: "Alvaro Pinto",
    cast: ["Lucía Ferrer", "Javier Núñez"],
    rating: 8.4,
    views: 118.9,
    addedAt: "2025-08-05",
    updatedAt: "2025-09-22",
    poster:
      "https://readdy.ai/api/search-image?query=Psychological%20thriller%20poster%20of%20a%20symmetrical%20room%20lined%20with%20mirrors%2C%20a%20woman%20standing%20in%20the%20center%20seen%20from%20behind%2C%20multiple%20reflections%20slightly%20out%20of%20sync%2C%20cold%20violet%20lighting%20with%20one%20amber%20doorway%2C%20unsettling%20precise%20composition%2C%20no%20text%2C%20film%20grain&width=600&height=900&seq=poster-jingxiang-15&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Symmetrical%20mirror-lined%20room%20with%20cold%20violet%20light%2C%20single%20woman%20silhouette%20facing%20away%2C%20warm%20amber%20doorway%20at%20the%20far%20end%2C%20ceramic%20tiles%2C%20unsettling%20psychological%20thriller%20cinematography%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=still-jingxiang-15&orientation=landscape",
    tagline: "房间里只有一个人，可镜子里的她一直在说话。",
    summary:
      "一位建筑声学专家受邀评估一栋古怪的宅邸，却发现每间房的镜像结构都会延迟她自己的动作。当延迟越来越长，她开始怀疑镜子里那个才是原件。",
    plot: [
      "女主角Elena是建筑声学专家，接到一份奇怪的委托：评估一栋旧宅的声学改造方案。宅子的主人没有露面，只留下一份要求极细的说明，其中一条是“不要在午夜之后打开西侧房间的灯”。",
      "影片前半段几乎全靠空间本身制造压力。宅邸的每一间房都有一面巨大的镜子，而镜中的像会出现零点几秒的延迟。Elena起初认为是视觉误差，用手机录像验证后，却发现延迟真实存在，而且在一天天变长。",
      "随着调查深入，她发现这栋房子的建造者是一位研究“自我认知延迟”的神经学家。剧情的核心谜题逐渐清晰：如果一个人的镜像开始独立行动，哪一个才是被观察的对象？影片没有把答案说破，而是用大量重复构图和心理暗示，让观众自己感到不适。",
      "结尾Elena打破西侧房间的镜子，镜中的人却先一步做出了动作。她走出宅邸时，画面短暂停顿在她的背影上——观众无法确定走出来的是谁。这个开放式结局是整部电影最狠的一刀。",
    ],
    tags: ["心理惊悚", "空间叙事", "开放式结局", "高概念"],
  },
  {
    id: "chao-xi-zhi-jian",
    title: "潮汐之间",
    type: "剧集",
    region: "海外",
    country: "美国",
    year: 2022,
    genres: ["剧情", "家庭", "悬疑"],
    language: "英语",
    duration: "全 8 集 / 单集 51 分钟",
    director: "Nora Whitfield",
    cast: ["Sienna Cole", "Peter Lang", "Ada Moore"],
    rating: 8.2,
    views: 102.3,
    addedAt: "2024-09-11",
    updatedAt: "2025-03-05",
    poster:
      "https://readdy.ai/api/search-image?query=Coastal%20family%20drama%20poster%20of%20a%20weathered%20wooden%20house%20on%20a%20cliff%20above%20a%20grey%20winter%20sea%2C%20a%20woman%20looking%20out%20of%20a%20window%2C%20drifting%20fog%2C%20muted%20slate%20and%20soft%20violet%20tones%20with%20one%20amber%20lamp%2C%20melancholic%20quiet%20mood%2C%20no%20text%2C%20cinematic%20grain&width=600&height=900&seq=poster-chaoxi-16&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Cliffside%20wooden%20house%20above%20a%20stormy%20grey%20ocean%20with%20fog%20rolling%20in%2C%20bare%20trees%2C%20muted%20slate%20and%20violet%20palette%2C%20single%20warm%20window%20light%2C%20melancholic%20cinematic%20family%20drama%20look%2C%20no%20text&width=1600&height=900&seq=still-chaoxi-16&orientation=landscape",
    tagline: "潮水带走的，从来不只是沙子。",
    summary:
      "父亲去世后，三兄妹回到海边老宅处理遗产。一场持续三天的风暴把他们困在屋里，也把三十年前那个夏天重新冲上岸。",
    plot: [
      "《潮汐之间》的开场是一场葬礼。三兄妹从不同城市回到海边老宅，准备用三天时间清点遗物、办完手续、各自回去继续生活。他们已经有六年没有同处一室。",
      "第二天，一场提前到来的风暴切断了渡轮和信号。剧集的绝大部分场景都发生在这栋房子里：堆满旧报纸的客厅、漏水的阁楼、永远关不严的落地窗。三个人一边整理遗物，一边小心翼翼地避开某个话题。",
      "那个话题在第三集被打开。三十年前的一个夏天，最小的妹妹在海边失踪了几个小时，回来后全家再没人提过这件事。随着旧照片、录音带和邻居的口述逐渐拼合，观众会发现每个人记住的版本都不一样，而父亲生前一直在维护其中一个版本。",
      "剧集没有把悬疑做成抓凶手的爽感。真相揭开时，没有人是恶人，只是所有人都在用各自的方式保护同一个人。最后风暴过去，兄妹三人在沙滩上把父亲的骨灰撒进海里，然后一起修好了那扇落地窗。",
    ],
    tags: ["家庭伦理", "海边小镇", "回忆叙事", "细腻"],
  },
  {
    id: "chang-an-jiu-meng",
    title: "长安旧梦",
    type: "剧集",
    region: "国产",
    country: "中国大陆",
    year: 2024,
    genres: ["古装", "历史", "剧情"],
    language: "国语",
    duration: "全 16 集 / 单集 44 分钟",
    director: "裴仲文",
    cast: ["萧既白", "苏婉之", "崔无咎", "裴十一"],
    rating: 8.8,
    views: 289.6,
    addedAt: "2025-06-02",
    updatedAt: "2025-10-05",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20poster%20of%20a%20lone%20scholar%20in%20dark%20robes%20standing%20on%20the%20veranda%20of%20an%20ancient%20palace%20at%20dusk%2C%20lanterns%20glowing%20amber%2C%20layered%20eaves%20and%20mist%2C%20deep%20violet%20and%20ink%20black%20tones%2C%20falling%20snow%2C%20no%20text%2C%20elegant%20cinematic%20composition%20with%20fine%20texture&width=600&height=900&seq=poster-changan-17&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20courtyard%20at%20dusk%20in%20light%20snow%2C%20layered%20wooden%20eaves%2C%20warm%20amber%20lanterns%2C%20mist%20and%20deep%20violet%20twilight%2C%20stone%20paving%20with%20thin%20snow%2C%20elegant%20cinematic%20period%20drama%20aesthetic%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=still-changan-17&orientation=landscape",
    tagline: "他写下的是一个朝代的结局，也是一个朋友的墓志铭。",
    summary:
      "一名掌管典籍的小吏，在王朝将倾的最后三年里，用一支笔记录下所有被修饰过的历史。他要保住的不只是书，还有几个人的名字。",
    plot: [
      "《长安旧梦》的主角不是帝王将相，而是秘书省的一名从八品小吏。他的工作是誊抄、校对、归档，日复一日。剧集开场，他正在抄录一份战报，抄到一半发现原件被人改过三个字，而那三个字足以让一位战死的将领变成逃兵。",
      "故事由此展开。十六集的篇幅横跨王朝最后的三年，外部是越来越近的战火，内部是越来越频繁的删改。小吏在权力夹缝中做着一件几乎不可能完成的事：把真实的东西留下来。他没有兵权，没有靠山，唯一能用的工具是“副本”和“遗忘”。",
      "剧集最精彩的部分是几场文戏：一场是关于一份名录该不该烧掉的争论，一场是三个人在雪夜喝酒，谁都不提明天会发生什么。服化道克制考究，没有大场面堆砌，反而让长安这座城显得更真实。",
      "结局城破，他把最重要的几卷书交给一个不相识的少年，自己回到官署坐下。镜头停在他笔尖落纸的一瞬。旁白只有一句：“那年冬天，长安下了很大的雪。”",
    ],
    tags: ["历史正剧", "文人风骨", "制作精良", "悲壮"],
  },
  {
    id: "mo-ban-di-tie",
    title: "末班地铁",
    type: "电影",
    region: "海外",
    country: "韩国",
    year: 2025,
    genres: ["惊悚", "悬疑", "犯罪"],
    language: "韩语",
    duration: "113 分钟",
    director: "정하윤",
    cast: ["김서아", "이도겸", "박준"],
    rating: 8.5,
    views: 156.8,
    addedAt: "2025-10-08",
    updatedAt: "2025-10-18",
    poster:
      "https://readdy.ai/api/search-image?query=Korean%20thriller%20poster%20of%20an%20empty%20subway%20carriage%20at%20night%2C%20flickering%20fluorescent%20light%2C%20a%20woman%20alone%20holding%20a%20phone%2C%20reflections%20in%20the%20dark%20window%2C%20cold%20violet%20and%20sickly%20amber%20grading%2C%20tense%20claustrophobic%20composition%2C%20no%20text%2C%20film%20grain&width=600&height=900&seq=poster-moban-18&orientation=portrait",
    still:
      "https://readdy.ai/api/search-image?query=Empty%20subway%20platform%20at%20midnight%2C%20flickering%20lights%2C%20long%20tunnel%20perspective%2C%20wet%20floor%20reflections%2C%20cold%20violet%20and%20amber%20cinematic%20grading%2C%20claustrophobic%20korean%20thriller%20aesthetic%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=still-moban-18&orientation=landscape",
    tagline: "最后一班车，载的不一定都是回家的人。",
    summary:
      "末班地铁在隧道里停了十九分钟。车门重新打开时，车厢里的七名乘客少了一个，而所有人都说自己什么都没看见。",
    plot: [
      "《末班地铁》几乎是一个单场景电影。深夜十一点五十七分，一列末班车驶入隧道后突然停车，灯光闪烁了十九分钟。重新启动后，一名乘客消失了，只留下一个掉在座位下的手提包。",
      "女主角是车厢里唯一一个注意到异常的人。她记得那个人坐在斜对面，穿着一件灰色外套，一直在看手机。但当她向其他乘客和随后赶到的警方描述时，所有人的说法都出现了微妙的不一致。",
      "影片的巧妙之处在于，它把悬疑建立在“记忆的不可靠”之上。随着调查深入，观众会发现每个乘客都在隐瞒一些与本案无关的事：有人逃税，有人出轨，有人只是不想被卷入麻烦。这些小小的谎言叠加起来，让真相变得异常难以辨认。",
      "结尾揭开谜底时，故事的残酷程度超出了类型片的预期。没有怪物，也没有连环杀手，只有一个在所有人都选择沉默的十九分钟里做出的决定。影片最后一个镜头停在监控画面里那节空车厢上，久久不动。",
    ],
    tags: ["密闭惊悚", "单场景", "社会派", "反转"],
  },
];